import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithRestApiByRequestUid,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { EstimatedTradeCostConfigState } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';
import { buildEstimatedTradeCostWidgetConfigSlice } from 'widgets/estimatedTradeCost/widget/store/configslice';
import { EstimatedTradeCostWidget } from './components/EstimatedTradeCostWidget';
import { estimatedTradeCostCapsuleDescription } from './components/description/estimatedTradeCostCapsuleDescription';
import { estimatedTradeCostStreamConfig } from 'widgets/estimatedTradeCost/widget/stream-config';
import { EstimatedTradeCostRequest } from 'widgets/estimatedTradeCost/store/data/EstimatedTradeCostRequest';
import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';

const { initialConfigState } = buildEstimatedTradeCostWidgetConfigSlice();

export const estimatedTradeCostWidgetStrategy: WidgetStrategyWithConfig<EstimatedTradeCostConfigState> &
    WidgetStrategyWithRestApiByRequestUid<
        EstimatedTradeCostRequest,
        EstimatedTradeCostApiResponse
    > = {
    title: 'Pre-Trade Cost',
    supportedHosts: ['layout'],
    reactComponentType: EstimatedTradeCostWidget,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: estimatedTradeCostCapsuleDescription,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.ExactlyOneOrder,
    initialConfigState,
    managedStreamConfig: estimatedTradeCostStreamConfig,
    getRequiredOrderColumns: () => ['rem'],
};
